module.exports = __webpack_public_path__ + "img/isSuccess_2.faf807ce.jpg";